import { getImageFromPage } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';

// Taglierina A4 Orizzontale (centrato, senza spaziatura interna)
// Equivalente al layout default con outer-padding ON + inner-padding OFF:
// gli elementi sono incollati tra loro e il gruppo è centrato sul foglio.
export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  const maxItemsInRow = Math.floor(
    gridParameters.pdf.width / gridParameters.format.width
  );
  const maxItemsInColumn = Math.floor(
    gridParameters.pdf.height / gridParameters.format.height
  );

  const leftMargin =
    (gridParameters.pdf.width - maxItemsInRow * gridParameters.format.width) /
    2;
  const topMargin =
    (gridParameters.pdf.height -
      maxItemsInColumn * gridParameters.format.height) /
    2;

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }

    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      image = await addWatermark(image);
    }

    let left = leftMargin;
    let top = topMargin;

    for (let j = 0; j < maxItemsInColumn; j++) {
      for (let i = 0; i < maxItemsInRow; i++) {
        pdfGrid.addImage(
          image,
          'JPEG',
          left,
          top,
          gridParameters.format.width,
          gridParameters.format.height
        );
        left += gridParameters.format.width;
      }
      left = leftMargin;
      top += gridParameters.format.height;
    }
  }

  const fileName = slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  return { pdfGrid, fileName };
}
